__turbopack_context__.v({
  "filtersWrapper": "ua2IsG_filtersWrapper",
  "leadDescription": "ua2IsG_leadDescription",
  "numberOfSubcategories": "ua2IsG_numberOfSubcategories",
  "previousButton": "ua2IsG_previousButton",
  "subcategoriesTitle": "ua2IsG_subcategoriesTitle",
  "subcategoriesWrapper": "ua2IsG_subcategoriesWrapper",
  "subcategoryItem": "ua2IsG_subcategoryItem",
  "subcategoryName": "ua2IsG_subcategoryName",
  "subcategoryNameActive": "ua2IsG_subcategoryNameActive",
});
